import { format } from 'fecha'

export default function dateToMonthStrFormat (date: Date): string {
  const intl = new Intl.DateTimeFormat('ru-RU', {
    month: 'long'
  })

  let month = intl.format(date)
  const lastChar = month.charAt(month.length - 1)

  if (lastChar === 'ь' || lastChar === 'й') {
    month = month.substring(0, month.length - 1)
    month += 'я'
  } else {
    month += 'а'
  }

  const day = format(date, 'D')
  const year = format(date, 'YYYY')

  return `${day} ${month} ${year}`
}
